// @flow
import type {StateType} from '../reducers';
import type {LoadingStatusActionType} from './';

export type LoadingStatusStateType = {
  activateSim?: StatusValueType,
  addMoney?: StatusValueType,
  changePassword?: StatusValueType,
  changePlanConfirmation?: StatusValueType,
  checkPaymentAuthorizationResult?: StatusValueType,
  checkPremiumEligibility?: StatusValueType,
  confirmCustomerOptionCommercial?: StatusValueType,
  confirmDeliveryAddress?: StatusValueType,
  confirmKeptPhoneNumber?: StatusValueType,
  confirmPayment?: StatusValueType,
  confirmPersonalInfo?: StatusValueType,
  confirmPlan?: StatusValueType,
  confirmRegionDuringActivate?: StatusValueType,
  confirmSimCardNumber?: StatusValueType,
  confirmSubscriptionSelectionDuringActivate?: StatusValueType,
  createAccount?: StatusValueType,
  createAccountDuringActivate?: StatusValueType,
  dashboard?: StatusValueType,
  deliveryContact?: StatusValueType,
  fetchActivationBonus?: StatusValueType,
  fetchAllSubscriptions?: StatusValueType,
  fetchContracts?: StatusValueType,
  fetchCustomer?: StatusValueType,
  fetchDetailedUsages?: StatusValueType,
  fetchFiles?: StatusValueType,
  fetchNotifications?: StatusValueType,
  fetchPaymentAuthentications?: StatusValueType,
  fetchReferralBonuses?: StatusValueType,
  fetchGodfatherBonus?: StatusValueType,
  fetchRio?: StatusValueType,
  fetchTimeline?: StatusValueType,
  fetchTopUps?: StatusValueType,
  fetchUsageAggregate?: StatusValueType,
  fetchUsages?: StatusValueType,
  fetchVoucher?: StatusValueType,
  getAvailablePhoneNumbers?: StatusValueType,
  initSignUp?: StatusValueType,
  initStripePaymentMean?: StatusValueType,
  loadingPlanForTurnBackOn?: StatusValueType,
  login?: StatusValueType,
  loginDuringActivate?: StatusValueType,
  loginDuringSignUp?: StatusValueType,
  redirectAfterActivating?: StatusValueType,
  redirectAfterLogin?: StatusValueType,
  redirectAfterOrderingSIM?: StatusValueType,
  redeemVoucher?: StatusValueType,
  refreshPaymentDetails?: StatusValueType,
  refreshPaymentsHistory?: StatusValueType,
  refreshAvailableVouchers?: StatusValueType,
  resetPassword?: StatusValueType,
  resetPasswordConfirmation?: StatusValueType,
  roamingOffer?: StatusValueType,
  signUpCheckOrderConsistencySaga?: StatusValueType,
  suspendSuccess?: StatusValueType,
  suspendSwapTerminateLine?: StatusValueType,
  swapActivateSuccess?: StatusValueType,
  switchPlanMode?: StatusValueType,
  terminateSuccess?: StatusValueType,
  topUpConfirmation?: StatusValueType,
  unsuspendSuccess?: StatusValueType,
  updateBillingAddressDuringProcess?: StatusValueType,
  updateLocale?: StatusValueType,
  validateEmail?: StatusValueType,
  verifyBonuses?: StatusValueType,
  verifyGodfather?: StatusValueType,
  verifyPromotionCode?: StatusValueType,
  getAvailableSimSaga?: StatusValueType,
};

type StatusValueType = {|
  isLoading?: boolean,
  error?: any,
|};

export const initialState: LoadingStatusStateType = {};

export default function loadingStatusReducer(
  state: LoadingStatusStateType = initialState,
  action: LoadingStatusActionType,
): LoadingStatusStateType {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state, //$FlowFixMe
        [action.payload.page]: {
          ...state[action.payload.page],
          isLoading: action.payload.isLoading,
        },
      };
    case 'SET_ERROR':
      return {
        ...state, //$FlowFixMe
        [action.payload.page]: {
          ...state[action.payload.page],
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
}

const statusSelector = (state: StateType, page: string): StatusValueType => {
  return state.loadingStatus[page];
};

export const isLoadingSelector = (state: StateType, page: string): boolean => {
  const status = statusSelector(state, page);
  return !!status && !!status.isLoading;
};

export const hasErrorSelector = (state: StateType, page: string): boolean => {
  const status = statusSelector(state, page);
  return status && !!status.error;
};

export const hasLoginErrorSelector = (
  state: StateType,
  page: string,
): ?boolean => {
  const error = errorSelector(state, page);
  return error && error.type === 'LOGIN_TIMEOUT';
};

export const errorSelector = (state: StateType, page: string): ?Object => {
  const status = statusSelector(state, page);
  return status && status.error;
};

export const errorTitleSelector = (state: StateType, page: string): ?string => {
  const error = errorSelector(state, page);
  return error && error.title;
};
